<template>
    <div>
        <v-dialog v-model="dialog" width="unset" style="max-width: 600px">
            <assignment-topic
              v-if="dialog"
              :assignment="dialog_assignment"
              :mode="dialog_mode"
              @close="dialog = false"
            />
        </v-dialog>
        <v-subheader v-if="assignments.length == 0" no-gutters><i>No assignments</i></v-subheader>
        <div class="mt-5" v-else></div>
        <lesson-assignment
          v-for="assignment in assignments"
          :key="assignment.id"
          :name="assignment.name"
          :count="assignment.count"
          :color="assignment.color"
          @decrement="put_assignment(assignment, (assignment.count > 1 ? assignment.count - 1 : 0))"
          @increment="put_assignment(assignment, assignment.count + 1)"
          @modify="dialog_modify(assignment)"
          class="mb-4 mt-0 mx-4"
        />
        <v-row no-gutters class="mx-4 mt-6">
            <v-col cols="12" align-self="center">
                <v-btn width="100%" small @click="dialog_new"><v-icon>add</v-icon></v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import LessonAssignment from './LessonAssignment.vue'
import AssignmentTopic from './AssignmentTopic.vue'

export default {
    name: 'LessonAssignmentList',
    components: {
        LessonAssignment,
        AssignmentTopic
    },
    data () {
        return {
            dialog: false,
            dialog_mode: '',
            dialog_assignment: null
        }
    },
    props: {
        student_id: Number
    },
    computed: {
        student () {
            return this.$store.getters['teacher/students'].find(s => s.id == this.student_id);
        },
        assignments () {
            return this.student.assignments;
        }
    },
    methods: {
        dialog_close () {
            this.dialog = false;
        },
        dialog_new () {
            this.dialog_mode = 'new';
            this.dialog = true;
        },
        dialog_modify (assignment) {
            this.dialog_assignment = assignment;
            this.dialog_mode = 'modify';
            this.dialog = true;
        },
        async put_assignment (assignment, count) {
            try {
                if ('lock' in assignment) {
                    return;
                }
                this.$set(assignment, 'lock', true);
                await this.$store.dispatch('teacher/put_assignment', {student: this.student, assignment, count});
            } finally {
                this.$delete(assignment, 'lock');
            }
        },
    },
};
</script>
